import React, { memo } from 'react';
import MessageFooter from '../MessageFooter/MessageFooter';
import styled from 'styled-components';
import { Animate, Box, Button, Card, ChatMessage, Flex, Image, Link, Relative, Text } from 'pcln-design-system';
import { HotelsOutline, FlightsOutline, CarsOutline, PackagesOutline } from '@pcln/brand';
import { products, productsType } from '../../constants';
import { TravelBotLogoImage } from '../../TravelBotLogoImage';
const StyledTripsLinkCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "Trips__StyledTripsLinkCard",
  componentId: "sc-xmmhxz-0"
})(["cursor:pointer;"]);
const StyledImage = /*#__PURE__*/styled(Image).withConfig({
  displayName: "Trips__StyledImage",
  componentId: "sc-xmmhxz-1"
})(["object-fit:cover;"]);
const CustomTruncate = /*#__PURE__*/styled(Text).withConfig({
  displayName: "Trips__CustomTruncate",
  componentId: "sc-xmmhxz-2"
})(["width:100% display:-webkit-box -webkit-line-clamp:1 -webkit-box-orient:vertical overflow:hidden text-overflow:ellipsis"]);
const BackUpImage = ({
  type
}) => {
  let IconType;
  if (type === 'STAY') {
    IconType = HotelsOutline;
  } else if (type === 'DRIVE') {
    IconType = CarsOutline;
  } else if (type === 'FLY') {
    IconType = FlightsOutline;
  } else if (type === 'PACKAGE') {
    IconType = PackagesOutline;
  }
  return IconType ? React.createElement(Card, {
    height: '100%',
    borderRadius: '8px',
    borderWidth: 0,
    color: 'primary.light'
  }, React.createElement(Flex, {
    width: ['48px', '88px'],
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }, React.createElement(IconType, {
    color: 'primary',
    size: '32px'
  }))) : null;
};
const getPackageTrips = trips => {
  const {
    type,
    isExpressDeal,
    checkStatusUrl,
    bundleComponents
  } = trips || {};
  const firstComponent = bundleComponents[0];
  const lastComponent = bundleComponents[bundleComponents.length - 1];
  const {
    cityName,
    stateName,
    type: componentType
  } = lastComponent || {};
  let name;
  if (componentType === productsType.DRIVE) {
    name = lastComponent.title;
  } else if (componentType === productsType.STAY) {
    name = `${cityName}${stateName ? `, ${stateName}` : ''}`;
  } else if (componentType === productsType.FLY) {
    name = lastComponent.header;
  }
  const title = `Trip to ${name}`;
  const travelStartDate = firstComponent.dateHeader.split('-')[0];
  const travelEndDate = lastComponent.dateHeader.split('-')[1];
  const pkgDateHeader = `${travelStartDate}-${travelEndDate}`;
  const pkgType = bundleComponents.reduce((accComp, curComp) => {
    const {
      type
    } = curComp;
    const productName = products[type];
    accComp.push(productName);
    return accComp;
  }, []).join(' + ');
  return {
    type,
    isExpressDeal,
    checkStatusUrl,
    title,
    dateHeader: pkgDateHeader,
    pkgType
  };
};
const TripCard = ({
  trip,
  actualCheckStatusUrl
}) => {
  var _a;
  let imageSrc, name, productName, brandImageUrl;
  const {
    type,
    title,
    dateHeader
  } = trip;
  name = title;
  const isPackage = type === productsType.PACKAGE;
  if (isPackage) {
    const {
      pkgType
    } = trip;
    productName = pkgType;
  } else {
    const {
      brandImageUrl: rcBrandImageUrl,
      type,
      header,
      imageUrl,
      scheduleInfo
    } = trip;
    imageSrc = imageUrl || ((_a = scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo[0]) === null || _a === void 0 ? void 0 : _a.companyLogoUrl);
    productName = products[type];
    name = name || header;
    brandImageUrl = rcBrandImageUrl;
  }
  return React.createElement(Text, {
    lineHeight: '16px'
  }, React.createElement(Card, {
    borderRadius: 16,
    p: 2,
    mb: 2,
    width: 1,
    color: 'background.lightest'
  }, React.createElement(Flex, {
    width: 1
  }, React.createElement(Box, null, React.createElement(Relative, {
    height: '100%',
    width: 1
  }, React.createElement(Flex, {
    height: '100%',
    width: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }, type ? imageSrc ? React.createElement(Flex, {
    width: '82px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }, React.createElement(StyledImage, {
    src: imageSrc,
    width: type === 'STAY' ? '82px' : null,
    borderRadius: '8px',
    height: type === 'STAY' ? '100%' : '29px'
  }), brandImageUrl ? React.createElement(Image, {
    src: brandImageUrl,
    height: '13px'
  }) : null) : React.createElement(BackUpImage, {
    type: type
  }) : null))), React.createElement(Flex, {
    flexDirection: 'column',
    pl: 3
  }, productName && React.createElement(Text, {
    color: 'text.light',
    fontSize: 0,
    mb: 1
  }, productName), name && React.createElement(Flex, null, React.createElement(CustomTruncate, {
    fontSize: 1,
    fontWeight: 'bold',
    m: 0,
    mb: 1
  }, name)), dateHeader && React.createElement(Text, {
    fontSize: 0,
    color: 'text',
    mb: 1
  }, dateHeader), actualCheckStatusUrl && React.createElement(Link, {
    target: '_blank',
    href: actualCheckStatusUrl
  }, React.createElement(Text, {
    fontSize: 0
  }, "View Trip"))))));
};
const displayMyTrips = (trips, deepLinkPrompt, displayOngoingTrips = false) => {
  return trips.map((trip, index) => {
    const {
      isCurrentTrip,
      checkStatusUrl,
      type
    } = trip;
    if (displayOngoingTrips && isCurrentTrip || !displayOngoingTrips && !isCurrentTrip) {
      const actualCheckStatusUrl = `${checkStatusUrl}${deepLinkPrompt || ''}`;
      const isPackage = type === productsType.PACKAGE;
      return React.createElement(Animate, {
        key: index,
        variant: 'slideInLeft',
        override: {
          transition: {
            delay: 0.1 * index || 0
          }
        }
      }, React.createElement(StyledTripsLinkCard, {
        onClick: function () {
          window.open(actualCheckStatusUrl);
        },
        borderWidth: 0,
        width: 1
      }, React.createElement(TripCard, {
        trip: isPackage ? getPackageTrips(trip) : trip,
        actualCheckStatusUrl: actualCheckStatusUrl
      })));
    }
    return null;
  });
};
const Trips = ({
  trips = [],
  deepLinkPrompt,
  tripHeaderMsg = "I'm happy to help! Below are your trips, please select the one you need help with:",
  hasMoreTrips = false
}) => {
  const hasOngoingTrips = trips.some(trip => trip.isCurrentTrip);
  const hasUpcomingTrips = trips.some(trip => !trip.isCurrentTrip);
  const isAskingAboutUpcomingTrips = tripHeaderMsg.indexOf('upcoming') !== -1;
  const TripsHeader = ({
    title
  }) =>
  // Only show header to upcoming and past trips
  title && (isAskingAboutUpcomingTrips || hasOngoingTrips) ? React.createElement(Text, {
    fontWeight: 'bold',
    my: 2
  }, title) : null;
  return (trips === null || trips === void 0 ? void 0 : trips.length) ? React.createElement(React.Fragment, null, React.createElement(Box, {
    mb: 3
  }, React.createElement(ChatMessage, {
    ml: '',
    mb: '8px',
    variation: 'initial',
    Icon: TravelBotLogoImage,
    message: React.createElement(React.Fragment, null, React.createElement(Text, {
      mb: 2
    }, tripHeaderMsg), hasOngoingTrips && React.createElement(React.Fragment, null, React.createElement(TripsHeader, {
      title: 'Your current trip'
    }), React.createElement(Box, {
      maxWidth: '450px'
    }, displayMyTrips(trips, deepLinkPrompt, true))), hasUpcomingTrips && React.createElement(React.Fragment, null, React.createElement(TripsHeader, {
      title: 'Upcoming trip(s)'
    }), React.createElement(Box, {
      maxWidth: '450px'
    }, displayMyTrips(trips, deepLinkPrompt, false)))),
    footer: React.createElement(MessageFooter, null)
  })), hasMoreTrips ? React.createElement(Box, {
    my: 3,
    ml: 3
  }, React.createElement(Button, {
    onClick: function () {
      window.open('/next-profile/trips');
    },
    variation: 'subtle'
  }, "View All Trips")) : null) : null;
};
export default memo(Trips);